/* RESPONSIBLE TEAM: team-channels */
export interface SenderEmailAddressSummaryWireFormat {
  id: number | string;
  name: string;
  email: string;
  status: string;
  verified: boolean;
  custom_bounce_valid: boolean;
  dmarc_valid: boolean;
  sender_email_address_settings_id: number;
}

export default class SenderEmailAddressSummary {
  readonly id: number | string;
  readonly name: string;
  readonly email: string;
  readonly status: string;
  readonly verified: boolean;
  readonly customBounceValid: boolean;
  readonly dmarcValid: boolean;
  readonly senderEmailAddressSettingsId: number;

  constructor(
    id: number | string,
    name: string,
    email: string,
    status: string,
    verified: boolean,
    customBounceValid: boolean,
    dmarcValid: boolean,
    senderEmailAddressSettingsId: number,
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.status = status;
    this.verified = verified;
    this.customBounceValid = customBounceValid;
    this.dmarcValid = dmarcValid;
    this.senderEmailAddressSettingsId = senderEmailAddressSettingsId;
  }

  static deserialize(json: SenderEmailAddressSummaryWireFormat): SenderEmailAddressSummary {
    return new SenderEmailAddressSummary(
      json.id.toString(),
      json.name,
      json.email,
      json.status,
      json.verified,
      json.custom_bounce_valid,
      json.dmarc_valid,
      json.sender_email_address_settings_id,
    );
  }

  static serialize(address: SenderEmailAddressSummary): SenderEmailAddressSummaryWireFormat {
    return {
      id: address.id,
      name: address.name,
      email: address.email,
      status: address.status,
      verified: address.verified,
      custom_bounce_valid: address.customBounceValid,
      dmarc_valid: address.dmarcValid,
      sender_email_address_settings_id: address.senderEmailAddressSettingsId,
    };
  }
}
